import { useEffect, useRef } from "react";

type AlertToastType = {
    autoDestroyAfterMS?: number;
    isOpen: boolean;
    closeToastFn: () => void;
};

const AlertToast: React.FC<AlertToastType> = ({
    autoDestroyAfterMS,
    children,
    closeToastFn,
    isOpen,
}) => {
    const toastRef = useRef<HTMLDivElement>(null);
    const progressBarRef = useRef<HTMLDivElement>(null);

    const handleCloseToast = () => {
        const toast = toastRef.current;
        toast!.style.opacity = "0";

        setTimeout(() => {
            closeToastFn();
        }, 300);
    };

    useEffect(() => {
        if (!autoDestroyAfterMS) return;

        const progressBar = progressBarRef.current;
        progressBar!.style.marginLeft = "-100%";

        const timeoutId = setTimeout(() => {
            progressBar!.style.transition = `all linear ${
                autoDestroyAfterMS - 100
            }ms`;
            progressBar!.style.marginLeft = "0%";

            setTimeout(handleCloseToast, autoDestroyAfterMS - 100);
        }, 100);

        return () => {
            clearTimeout(timeoutId);
        };
    }, [autoDestroyAfterMS]);

    return isOpen ? (
        <section ref={toastRef} className="c-alert-toast">
            <div className="c-alert-toast__inner-container">
                {children}
                <button
                    onClick={handleCloseToast}
                    className="c-alert-toast__close-button"
                >
                    X
                </button>
            </div>

            <div
                ref={progressBarRef}
                className="c-alert-toast__close-timer"
            ></div>
        </section>
    ) : null;
};

export default AlertToast;
